import { render } from "./EvidenceManagementContent.vue?vue&type=template&id=d7fb5846"
import script from "./EvidenceManagementContent.vue?vue&type=script&lang=js"
export * from "./EvidenceManagementContent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/abrams360/irm/www.impactirm.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__